import React, { useState } from "react";
import { ServiceCard } from "./ServiceCard";
import peanutsimg1 from "../assets/img/peanuts.webp"

import serviceimag1 from "../assets/img/onion.jpg";
import serviceimag2 from "../assets/img/dried onion.jpg";
import serviceimag3 from "../assets/img/cumin seeds.jpeg";
import serviceimag4 from "../assets/img/kinnu.jpeg";
import serviceimag5 from "../assets/img/pomegranate.jpg";
import serviceimag6 from "../assets/img/dates.jpg";
import serviceimag7 from "../assets/img/isabgol.jpg";
import serviceimag8 from "../assets/img/peanuts.webp";
import serviceimag9 from "../assets/img/peanut roasted.jpg";
import serviceimag10 from "../assets/img/cashew.jpg";
import serviceimag11 from "../assets/img/natural-honey.jpg";
export const productDetails = {
  "fresh-onion": {
    title: "Bold Peanut",
    description: "Premium quality bold peanuts for various uses.",
    specifications: {
      Type: "Bold Peanuts",

      Origin: "India",
      Count: "38/42 , 40/50 , 50/60 & 60/70",
      Cleaning: "Sortex Cleaned",
      Moisture: "8% max",
      Admixture: "1% max",
      Foreignmaterial: "0.5%max",
      Brokenandsplits: "1%max",
      Oilcontent: "48-52%",
      Packing: "25/50kg Jute bag , pp bag , vacuum bag",
    },
    image: peanutsimg1, // Replace with actual image path
  },
  "dried-onion": {
    title: "Dried Onion",
    description: "High-quality dried onions, perfect for cooking.",
    specifications: {
      Type: "Dried Onion",
      "Country of Origin": "India",
      "Processing Type": "Dehydrated",
    },
    image: peanutsimg1, // Replace with actual image path
  },
  "cumin-seeds": {
    title: "Bold Peanut",
    description: "Premium quality bold peanuts for various uses.",
    specifications: {
      Type: "Bold Peanuts",
      Count: "38/42, 40/50, 50/60, 60/70",
      Moisture: "7% max",
      "Foreign material": "0.5% max",
      "Oil content": "48-52%",
      Packing: "25/50kg Jute bag, pp bag, vacuum bag",
    },
    image: peanutsimg1, // Replace with actual image path
  },
  "kinnu": {
    title: "Bold Peanut",
    description: "Premium quality bold peanuts for various uses.",
    specifications: {
      Type: "Bold Peanuts",
      Count: "38/42, 40/50, 50/60, 60/70",
      Moisture: "7% max",
      "Foreign material": "0.5% max",
      "Oil content": "48-52%",
      Packing: "25/50kg Jute bag, pp bag, vacuum bag",
    },
    image: peanutsimg1, // Replace with actual image path
  },
  "pomegranate": {
    title: "Bold Peanut",
    description: "Premium quality bold peanuts for various uses.",
    specifications: {
      Type: "Bold Peanuts",
      Count: "38/42, 40/50, 50/60, 60/70",
      Moisture: "7% max",
      "Foreign material": "0.5% max",
      "Oil content": "48-52%",
      Packing: "25/50kg Jute bag, pp bag, vacuum bag",
    },
    image: peanutsimg1, // Replace with actual image path
  },
  "dates": {
    title: "Bold Peanut",
    description: "Premium quality bold peanuts for various uses.",
    specifications: {
      Type: "Bold Peanuts",
      Count: "38/42, 40/50, 50/60, 60/70",
      Moisture: "7% max",
      "Foreign material": "0.5% max",
      "Oil content": "48-52%",
      Packing: "25/50kg Jute bag, pp bag, vacuum bag",
    },
    image: peanutsimg1, // Replace with actual image path
  },
  "isabgol": {
    title: "Bold Peanut",
    description: "Premium quality bold peanuts for various uses.",
    specifications: {
      Type: "Bold Peanuts",
      Count: "38/42, 40/50, 50/60, 60/70",
      Moisture: "7% max",
      "Foreign material": "0.5% max",
      "Oil content": "48-52%",
      Packing: "25/50kg Jute bag, pp bag, vacuum bag",
    },
    image: peanutsimg1, // Replace with actual image path
  },
  "peanuts": {
    title: "Bold Peanut",
    description: "Premium quality bold peanuts for various uses.",
    specifications: {
      Type: "Bold Peanuts",
      Count: "38/42, 40/50, 50/60, 60/70",
      Moisture: "7% max",
      "Foreign material": "0.5% max",
      "Oil content": "48-52%",
      Packing: "25/50kg Jute bag, pp bag, vacuum bag",
    },
    image: peanutsimg1, // Replace with actual image path
  },
  "roasted-peanuts": {
    title: "Bold Peanut",
    description: "Premium quality bold peanuts for various uses.",
    specifications: {
      Type: "Bold Peanuts",
      Count: "38/42, 40/50, 50/60, 60/70",
      Moisture: "7% max",
      "Foreign material": "0.5% max",
      "Oil content": "48-52%",
      Packing: "25/50kg Jute bag, pp bag, vacuum bag",
    },
    image: peanutsimg1, // Replace with actual image path
  },
  "cashew": {
    title: "Bold Peanut",
    description: "Premium quality bold peanuts for various uses.",
    specifications: {
      Type: "Bold Peanuts",
      Count: "38/42, 40/50, 50/60, 60/70",
      Moisture: "7% max",
      "Foreign material": "0.5% max",
      "Oil content": "48-52%",
      Packing: "25/50kg Jute bag, pp bag, vacuum bag",
    },
    image: peanutsimg1, // Replace with actual image path
  },
  "natural-honey": {
    title: "Bold Peanut",
    description: "Premium quality bold peanuts for various uses.",
    specifications: {
      Type: "Bold Peanuts",
      Count: "38/42, 40/50, 50/60, 60/70",
      Moisture: "7% max",
      "Foreign material": "0.5% max",
      "Oil content": "48-52%",
      Packing: "25/50kg Jute bag, pp bag, vacuum bag",
    },
    image: peanutsimg1, // Replace with actual image path
  },
};
export const OurServices = () => {
  const servicesdata = [
    {
      id: 1,
      serviceimage: serviceimag1,
      cardtitle: "Fresh Onion",
      title: "Bold Peanut",
      description: "Premium quality bold peanuts for various uses.",
      specifications: {
        Type: "Bold Peanuts",
        Count: "38/42, 40/50, 50/60, 60/70",
        Moisture: "7% max",
        "Foreign material": "0.5% max",
        "Oil content": "48-52%",
        Packing: "25/50kg Jute bag, pp bag, vacuum bag",
      },
      image: peanutsimg1, // Replace with actual image path
    },
    {
      id: 2,
      serviceimage: serviceimag2,
      cardtitle: "Dried Onion",
      title: "Dried Onion",
      description: "High-quality dried onions, perfect for cooking.",
      specifications: {
        Type: "Dried Onion",
        "Country of Origin": "India",
        "Processing Type": "Dehydrated",
      },
      image: peanutsimg1, // Replace with actual image path
    },
    {
      id: 3,
      serviceimage: serviceimag3,
      cardtitle: "Cumin Seeds",
      title: "Bold Peanut",
      description: "Premium quality bold peanuts for various uses.",
      specifications: {
        Type: "Bold Peanuts",
        Count: "38/42, 40/50, 50/60, 60/70",
        Moisture: "7% max",
        "Foreign material": "0.5% max",
        "Oil content": "48-52%",
        Packing: "25/50kg Jute bag, pp bag, vacuum bag",
      },
      image: peanutsimg1, // Replace with actual image path
    },
    {
      id: 4,
      serviceimage: serviceimag4,
      cardtitle: "Kinnu",
      title: "Bold Peanut",
      description: "Premium quality bold peanuts for various uses.",
      specifications: {
        Type: "Bold Peanuts",
        Count: "38/42, 40/50, 50/60, 60/70",
        Moisture: "7% max",
        "Foreign material": "0.5% max",
        "Oil content": "48-52%",
        Packing: "25/50kg Jute bag, pp bag, vacuum bag",
      },
      image: peanutsimg1, // Replace with actual image path
    },
    // Repeat for the rest of the products
  ];
  
  const [currentIndex, setCurrentIndex] = useState(0);
  const visibleItems = 1; // Number of items visible at once
  const totalItems = servicesdata.length;

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? totalItems - visibleItems : prevIndex - 1
    );
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex >= totalItems - visibleItems ? 0 : prevIndex + 1
    );
  };

  return (
    <section className="service" id="services">
      <div className="service-container">
        <div className="section-header">
          <h3 className="service-header-title">Our Services</h3>
        </div>
        <div className="service-carousel">
          <div
            className="service-inner"
            style={{
              transform: `translateX(-${(currentIndex / visibleItems) * 100}%)`,
              transition: "transform 0.5s ease",
              display: "flex",
              width: `${(totalItems / visibleItems) * 100}%`,
            }}
          >
            {servicesdata.map((serviceitem) => (
              <ServiceCard key={serviceitem.id} serviceitem={serviceitem} />
            ))}
          </div>
          <button className="carousel-button prev" onClick={goToPrevious}>
            ❮
          </button>
          <button className="carousel-button next" onClick={goToNext}>
            ❯
          </button>
        </div>
      </div>
    </section>
  );
};
